import React from 'react';
import IdleTimer from 'react-idle-timer';
import { generalCreators } from '../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../redux/general/general-constant';
import { useDispatch, useSelector } from 'react-redux';
import { AUTH_STATE_KEY, authStateSelector } from '../../auth-reducer';
import { authCreators } from '../../auth-action';
import { envConfig } from '../../../config';
import { AUTH_LOCAL_STORAGE_KEY, COGNITO_CHALLENGE } from '../../auth-constant';
import { getLocalStorage, isBoolean } from '../../../shared/helpers/utility';

export const AppIdleTimer: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const isRemember = isBoolean(getLocalStorage(AUTH_LOCAL_STORAGE_KEY.IS_REMEMBER));
  const isLoggedIn = useSelector(authStateSelector(AUTH_STATE_KEY.STATUS));

  const onIdle = () => {
    if (isLoggedIn === COGNITO_CHALLENGE.LOGIN_SUCCESS && !isRemember) {
      dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.TNC_MODAL, {
        visible: false,
        contentHtml: undefined
      }));
      dispatch(authCreators.logOut());
      dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        modalTitle: 'main.error.timeout.title',
        modalContent: 'main.error.timeout.content',
        type: MODAL_TYPE.ERROR
      }));
    }
  };

  return (
    <IdleTimer
      element={document}
      onIdle={onIdle}
      debounce={0}
      timeout={1000 * 60 * envConfig.timeOutIdleTimer}
      stopOnIdle={isLoggedIn ? false : true}
    />
  );
};

type Props = {

};
